import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  carrierNames: [],
  groupNames: [],
  selectedPrograms: [],
  selectedDrugLists: [],

  carrierSearch: "",
  groupSearch: "",
  programSearch: "",
  druglistSearch: "",

  sorting: [],

  // Dropdown option lists
  availableCarriers: [],
  availableGroups: [],
  availablePrograms: [],
  availableDrugLists: [],

  // Maps
  programNameToIdMap: {},
  drugListNameToIdMap: {},
  carrierToGroupsMap: {},
  groupToCarrierMap: {},
};

const cagMappingsSlice = createSlice({
  name: "cagMappingsFilters",
  initialState,
  reducers: {
    setCagFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetCagFilters(state) {
      return {
        ...initialState,
        availableCarriers: state.availableCarriers,
        availableGroups: state.availableGroups,
        availablePrograms: state.availablePrograms,
        availableDrugLists: state.availableDrugLists,
        programNameToIdMap: state.programNameToIdMap,
        drugListNameToIdMap: state.drugListNameToIdMap,
        carrierToGroupsMap: state.carrierToGroupsMap,
        groupToCarrierMap: state.groupToCarrierMap,
      };
    },
  },
});

export const { setCagFilters, resetCagFilters } = cagMappingsSlice.actions;
export default cagMappingsSlice.reducer;
